import React from "react";
import Principal from "../../components/Home/InfoEmpresa";
import Equipos from "../../components/Home/Equipos";
import Servicio from "../../components/Home/Servicio";
import Historias from "../../components/Home/Historias";
import Logros from "../../components/Home/Logros";

export default function Home() {
  return (
    <div className="content">
      <Principal/>
      <Servicio/>
      <Equipos/>
      <Historias/>
      <Logros/>
    </div>
  );
}
